import { render, staticRenderFns } from "./Autowater.vue?vue&type=template&id=090fdfb0&scoped=true"
import script from "./Autowater.vue?vue&type=script&lang=js"
export * from "./Autowater.vue?vue&type=script&lang=js"
import style0 from "./Autowater.vue?vue&type=style&index=0&id=090fdfb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090fdfb0",
  null
  
)

export default component.exports